import { objectCardDocuments } from './ObjectCardDocuments.js'

export const cardPropertyDocuments = {
  mixins: [objectCardDocuments],
  props: {
    tabProp: {
      type: Object,
      required: true
    },
    object: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const data = {
      propertyKey: this.tabProp.key
    }
    const config = this.tabProp || this.config || {}
    if (config.componentProps) {
      Object.assign(data, config.componentProps)
    }
    data.addOnly = !!config.addOnly
    return data
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  watch: {
    object: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  }
}
